import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { useSelector, shallowEqual } from 'react-redux';
import { reducer, name } from './slice';
import saga from './saga';
import makeAuth from './selectors';

export default function useAuth() {
  useInjectReducer({ key: name, reducer });
  useInjectSaga({ key: name, saga });
  useSelector(makeAuth(), shallowEqual);
  return null;
}
